// eslint-disable-next-line import/extensions
import { get, post, del } from './base.js';

const URL = '/notifications';

export const PostFCMToken = (payload, config) =>
  post(`${URL}/fcm-notifications/`, payload, config);
export const DeleteFCMToken = (token, config) =>
  del(`${URL}/fcm-notifications/?fcm_token=${token}`, config);
export const GetUserNotification = (page, config) =>
  get(`${URL}/user-notifications/?page=${page}&page_size=10`, config);
export const GetUserHasNewNotification = config =>
  get(`${URL}/user-notifications/has-new/`, config);
